import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "13", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 10v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 15v1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m14.6 11.5-.87.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m10.27 14-.87.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m14.6 14.5-.87-.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m10.27 12-.87-.5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FolderCog2";
const FolderCog2 = memo(themed(Icon));
export {
  FolderCog2
};
//# sourceMappingURL=folder-cog-2.js.map
